import { render } from "./BeneficiosClaveVideoNew.vue?vue&type=template&id=72b89ddc&scoped=true"
import script from "./BeneficiosClaveVideoNew.vue?vue&type=script&lang=js"
export * from "./BeneficiosClaveVideoNew.vue?vue&type=script&lang=js"

import "./BeneficiosClaveVideoNew.vue?vue&type=style&index=0&id=72b89ddc&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b89ddc"]])

export default __exports__